import { Controller } from "stimulus";

const PASSWORD_LENGTH = 8;

export default class extends Controller {
  static targets = ["password", "warningMessage", "submit"];

  showPassword(e) {
    if (this.passwordTarget.type === "password") {
      e.target.classList.remove("fa-eye");
      e.target.classList.add("fa-eye-slash");
      this.passwordTarget.type = "text";
    } else {
      e.target.classList.remove("fa-eye-slash");
      e.target.classList.add("fa-eye");
      this.passwordTarget.type = "password";
    }
  }

  checkPasswordLength() {
    if (this.passwordTarget.value.length < PASSWORD_LENGTH) {
      this.passwordTarget.classList.add("border-danger");
      this.warningMessageTarget.classList.remove("d-none");
      this.submitTarget.disabled = true;
    } else {
      this.passwordTarget.classList.remove("border-danger");
      this.warningMessageTarget.classList.add("d-none");
      this.submitTarget.disabled = false;
    }
  }
}
